var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.parseImageList.length > 0)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.downloadMultipleImages}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+" 共"+_vm._s(_vm.parseImageList.length)+"张\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }